// components/DiscountBanner/styles.js
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  discountBannerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  discountBanner: {
    backgroundColor: '#2A007E', // Deep purple color
    borderRadius: '50px',
    padding: '12px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '500px',
    height: '30px',
  },
  starIcon: {
    marginRight: '8px',
  },
  discountText: {
    color: '#F6FF00', // Bright yellow text
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
  },
}));
